import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { JobStatusModal } from 'components/modals';
import { useDownloadFile } from 'store/files';
import { useModalContext } from 'store/modal';
import { useExportSurveyResults } from 'store/surveys';

export const useExportSurveyResultsJob = () => {
  const { t } = useTranslation();
  const { openModal } = useModalContext();

  const { mutate: downloadFile } = useDownloadFile();
  const { mutate: exportSurveyResults, isLoading: isExporting } =
    useExportSurveyResults();

  const exportSurveyResultsJob = ({ surveyId }: { surveyId: string }) => {
    exportSurveyResults(
      { surveyId },
      {
        onSuccess: ({ data }) => {
          openModal({
            component: JobStatusModal,
            props: {
              jobId: data.jobId,
              queue: data.queue,
              title: t('dashboard.download_xls'),
              description: t(
                'employees.org_structure.import.in_progress.description',
              ),
              onSuccess: (job, closeJobModal) => {
                const fileId = job.output?.fileId;

                if (!fileId) {
                  toast.error(t('errors.genericErrorMessage'));
                  closeJobModal();
                  return;
                }

                downloadFile(
                  { fileId },
                  {
                    onSettled: () => {
                      closeJobModal();
                    },
                  },
                );
              },
            },
            closable: false,
          });
        },
      },
    );
  };

  return { exportSurveyResults: exportSurveyResultsJob, isExporting };
};
